import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import axios from 'axios'
import Auth from '../auth'

export const EMPLOYEE_CODE_IMPORT_ENDPOINT = `${API_BASE}employee-code-imports/`

export default class EmployeeAPI {
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `UserAPI`.
   *
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new EmployeeAPI(cls)
  }

  list({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),

      // Sorting
      ordering: ApiFilter.create({ key: 'ordering' }),

      // Search
      search: ApiFilter.create({ key: 'search' }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
    }

    const promise = axios
      .get(`${EMPLOYEE_CODE_IMPORT_ENDPOINT}`, options)
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List EmployeeCodeImport API error',
          rethrowErrors: true,
        }),
      )
    return promise
  }
}
